import { customElement } from 'lit/decorators.js'
import { html, LitElement, type CSSResultGroup } from 'lit'
import { consume } from '@lit/context'
import { state } from 'lit/decorators.js'
import { style } from './configurator-add-to-basket-button.style.js'
import { hostStyle } from '@cloudsuite/mosaic-shared/styles/host.style.js'
import { addToBasketContext, type AddToBasketContext } from 'components/ordering/configurator/components/context/context-definition.js'
import { AddToBasketSuccess } from 'components/ordering/add-to-basket/basket-parser.js'
import type { OrderFormButtonState } from 'components/ordering/order-form/components/types.js'
import 'components/ordering/order-form/components/order-form-button.js'

@customElement('csc-configurator-add-to-basket-button')
export class CSCConfiguratorAddToBasketButton extends LitElement {
  static override styles?: CSSResultGroup = [hostStyle, style]

  @consume({ context: addToBasketContext })
  addToBasket!: AddToBasketContext

  @state()
  buttonState: OrderFormButtonState = 'initial'

  private handleAddToBasket = async () => {
    this.buttonState = 'pending'
    const result = await this.addToBasket()
    if (result instanceof AddToBasketSuccess) {
      this.buttonState = 'confirmed'
    } else {
      this.buttonState = 'error'
    }
  }

  override render() {
    return html`
      <csc-order-form-button
        layout="default"
        state="${this.buttonState}"
        @order-form-add="${this.handleAddToBasket}"
      ></csc-order-form-button>`
  }
}
